import Image from "next/image";
import React from "react";
export default function Logo() {
  return (
    <section>
      <Image
        src={`https://pub-db3cf94a33a742049ee99ef79f6a7392.r2.dev/logo.png`}
        width={80}
        height={80}
        priority="eager"
        loading="eager"
        className="w-full h-full"
        alt="logo"
        unoptimized
      />
    </section>
  );
}